import { supabaseClient } from '../supabase';
import baseDataProvider from '../supabase/baseDataProvider';

const inboundContactsDataProvider = {
  ...baseDataProvider,
  getList: async (resource, params) => {
    if ( resource === 'inbound_contacts' ) {
      resource = 'inbound_contacts_view'
    }

    if (params.filter?.['phone@ilike']) {
      params.filter['phone@ilike'] = params.filter['phone@ilike'].replace(/^(%?)0([67])/, '$1+33$2')
    }

    return await baseDataProvider.getList(resource, params)
  },
  getOne: async (resource, params) => {
    if (resource === 'inbound_contacts') {
      resource = 'inbound_contacts_view'
    }

    return await baseDataProvider.getOne(resource, params)
  },
  deleteMany: async (resource, params) => {
    const chunkSize = 100;
    const chunks = [];
    for (let i = 0; i < params.ids.length; i += chunkSize) {
      chunks.push(params.ids.slice(i, i + chunkSize));
    }
    
    const errors = [];
    
    for (const chunk of chunks) {
      const { error } = await supabaseClient
        .from(resource)
        .delete()
        .in('id', chunk)

      if (error) {
        errors.push(error)
      }
    }

    if (errors.length > 0) {
      throw new Error(`Errors occurred in deleteMany: ${errors.map(e => e.message).join(', ')}`)
    }

    return { data: params.ids }
  },
}

export const dataProvider = inboundContactsDataProvider